import {hoistCmp, uses, XH} from '@xh/hoist/core';
import {DepositEditorModel, DepositsDialogModel} from './DepositsDialogModel';
import {dialog} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button, refreshButton} from '@xh/hoist/desktop/cmp/button';
import {filler, fragment} from '@xh/hoist/cmp/layout';
import {storeFilterField} from '@xh/hoist/cmp/store';
import {form} from '@xh/hoist/cmp/form';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {dateInput, numberInput, textArea} from '@xh/hoist/desktop/cmp/input';
import {LocalDate} from '@xh/hoist/utils/datetime';

export const depositsDialog = hoistCmp.factory<DepositsDialogModel>({
    model: uses(DepositsDialogModel),
    render({model}) {
        return dialog({
            style: {
                width: 800,
                height: 600
            },
            isOpen: model.isOpen,
            onClose: () => model.close(),
            title: 'Portfolio Deposits',
            icon: Icon.dollarSign(),
            item: fragment(
                panel({
                    tbar: tbar(),
                    item: grid(),
                    mask: model.apiTask
                }),
                portfolioDepositEditorDialog({model: model.editorModel})
            )
        });
    }
});

const tbar = hoistCmp.factory<DepositsDialogModel>(({model}) =>
    toolbar(
        button({
            text: 'Add',
            omit: XH.entitlementService.isShadow,
            icon: Icon.plus(),
            intent: 'success',
            onClick: () => model.addDepositAsync()
        }),
        button({
            text: 'Clone',
            omit: XH.entitlementService.isShadow,
            icon: Icon.copy(),
            disabled: !model.selectedDeposit,
            onClick: () => model.cloneDepositAsync()
        }),
        button({
            text: 'Edit',
            omit: XH.entitlementService.isShadow,
            icon: Icon.edit(),
            intent: 'primary',
            disabled: !model.selectedDeposit,
            onClick: () => model.editDepositAsync()
        }),
        button({
            text: 'Delete',
            omit: XH.entitlementService.isShadow,
            icon: Icon.delete(),
            intent: 'danger',
            disabled: !model.selectedDeposit,
            onClick: () => model.deleteDepositAsync()
        }),
        filler(),
        storeFilterField({model: model.gridModel, matchMode: 'any'}),
        refreshButton({onClick: () => model.refresh()})
    )
);

const portfolioDepositEditorDialog = hoistCmp.factory<DepositEditorModel>({
    model: uses(DepositEditorModel),
    render({model}) {
        return dialog({
            style: {
                width: 'fit-content',
                height: 'fit-content'
            },
            isOpen: model.isOpen,
            onClose: () => model.close(),
            title: `${model.isNew ? 'Add' : 'Edit'} Deposit`,
            icon: model.isNew ? Icon.add() : Icon.edit(),
            item: panel({
                item: form({
                    model: model.formModel,
                    fieldDefaults: {minimal: true, commitOnChange: true},
                    items: [
                        formField({
                            field: 'asOfDate',
                            item: dateInput({
                                valueType: 'date',
                                showActionsBar: true,
                                showPickerOnFocus: true,
                                dayPickerProps: {
                                    disabled: day => !LocalDate.from(day).isWeekday
                                }
                            })
                        }),
                        formField({field: 'amount', item: numberInput()}),
                        formField({field: 'notes', item: textArea()})
                    ]
                }),
                bbar: toolbar({
                    items: [
                        filler(),
                        button({
                            text: 'Cancel',
                            icon: Icon.close(),
                            onClick: () => model.close()
                        }),
                        button({
                            text: 'Save',
                            icon: Icon.check(),
                            outlined: true,
                            intent: 'success',
                            disabled: !model.formModel.isValid,
                            onClick: () => model.save()
                        })
                    ]
                })
            })
        });
    }
});
